import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["base", "medium", "large"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
export var responsiveProps = function responsiveProps(props, addAtSymbol) {
  for (var _len = arguments.length, variantNames = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    variantNames[_key - 2] = arguments[_key];
  }
  var mapped = variantNames.reduce(function (res, variantName) {
    var getNewValue = function getNewValue(value) {
      return "".concat(addAtSymbol ? '@' : '').concat(value);
    };
    var value = props[variantName];
    if (_typeof(value) !== 'object') return res;
    var bps = Object.keys(value);
    var _ref = value,
      base = _ref.base,
      medium = _ref.medium,
      large = _ref.large,
      out = _objectWithoutProperties(_ref, _excluded);
    res[variantName] = out;
    if (medium !== undefined) {
      out[getNewValue('baseToMedium')] = base;
      out[bps.includes('large') ? getNewValue('mediumToLarge') : getNewValue('medium')] = medium;
    } else out[bps.includes('large') ? getNewValue('baseToLarge') : getNewValue('base')] = base;
    if (large !== undefined) out[getNewValue('large')] = large;
    return res;
  }, {});
  return _objectSpread(_objectSpread({}, props), mapped);
};
export default responsiveProps;